// ABOUTME: Smart wrapper for the Operational Hours entity — owns useOperationalHoursEntity and reports state via context.
// ABOUTME: Renders skeleton/error/form so the page no longer branches per entity.
import React from 'react'

import {useOperationalHoursEntity} from '../hooks/useOperationalHoursEntity'
import {useEntityFormContext, useRegisterEntityForm} from '../context/EntityFormContext'
import {EntityContentEmpty} from './EntityContentEmpty'
import {EntityContentError} from './EntityContentError'
import {EntityContentSkeleton} from './EntityContentSkeleton'
import {OperationalHoursForm} from './OperationalHoursForm'

export const OperationalHoursEntityForm: React.FC = () => {
  const ctx = useEntityFormContext()
  const {config, isLoading, error, isSaving, actions} = useOperationalHoursEntity({
    countryId: ctx.countryId,
    businessLine: ctx.businessLine,
    scopeId: ctx.selectedScopeId,
    pendingScope: ctx.pendingScope,
    rootScopeId: ctx.rootScopeId,
  })

  useRegisterEntityForm(actions, isSaving)

  if (isLoading) return <EntityContentSkeleton />
  if (error) return <EntityContentError />
  if (!config) return <EntityContentEmpty />

  return (
    <OperationalHoursForm
      key={ctx.formResetKey}
      config={config}
      isReadOnly={ctx.isReadOnly}
      isCountryDefault={ctx.isCountryDefault}
      onDirtyChange={ctx.onDirtyChange}
      onValidChange={ctx.onValidChange}
      onValuesChange={actions.handleValuesChange}
      dayCodes={ctx.dayCodes}
    />
  )
}
